import React from 'react';
import { Drawer } from '@mui/material';
var extendMenuItemsWithProps = function (children, selectedType, onItemClick, isGroupExpanded, onGroupClick) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child) && child.props.children) {
            return React.cloneElement(child, {
                isGroupExpanded: isGroupExpanded,
                onGroupClick: onGroupClick,
                children: extendMenuItemsWithProps(child.props.children, selectedType, onItemClick, isGroupExpanded, onGroupClick),
            });
        }
        else if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                isSelected: child.props.type === selectedType,
                onClick: onItemClick,
            });
        }
        else {
            return child;
        }
    });
};
var MainMenu = function (_a) {
    var expanded = _a.expanded, selectedType = _a.selectedType, onItemClick = _a.onItemClick, isGroupExpanded = _a.isGroupExpanded, onGroupClick = _a.onGroupClick, children = _a.children;
    var displayVariant = expanded ? 'expanded' : 'collapsed';
    return (React.createElement(Drawer, { variant: 'persistent', transitionDuration: 0, open: true, classes: {
            root: "mainMenu__drawer mainMenu__drawer--" + displayVariant,
            paper: 'mainMenu__paper',
        } }, extendMenuItemsWithProps(children, selectedType, onItemClick, isGroupExpanded, onGroupClick)));
};
export default MainMenu;
//# sourceMappingURL=MainMenu.js.map